import React, { memo, forwardRef, useImperativeHandle, useState, useCallback } from "react";
import Modal from "@mui/material/Modal";
import AppButton from "components/app-button";
import serveRequestErrors from "common/serve-request-errors";
import api from "services/api";


const AppAssignmentReadyModal = forwardRef((props, ref) => {
    const [visible, setVisible] = useState(false);
    const [assignmentId, setAssignmentId] = useState(null);
    const [loading, setLoading] = useState(false);

    useImperativeHandle(ref, () => ({
        onHandleDismiss,
        onHandleShow: (id) => {
            setAssignmentId(id);
            setVisible(true);
        }
    }));


    const onHandleDismiss = useCallback(() => {
        setVisible(false);
        setAssignmentId(null);
    }, []);

    const handleConfirm = async () => {
        setLoading(true);

        try {
            await api.post.assignment.updateStatus(assignmentId, "READY");
            if (props.onHandleGetList) props.onHandleGetList();
            setVisible(false);
        } catch (error) {
            serveRequestErrors(error);
        }

        setVisible(false);
        setLoading(false);
    };

    return (
        <Modal classes={{ root: "app-assignment-ready-modal" }} open={visible} onClose={onHandleDismiss} aria-labelledby="assignment-ready-modal" aria-describedby="assignment-ready-modal">
            <div className="assignment-ready-modal">
                <div className="assignment-ready-modal__main">
                    <div className="assignment-ready-modal__header">
                        <p className="assignment-ready-modal__title">Ready to take the exam?</p>
                    </div>

                    <form className="assignment-ready-modal__body" >
                        <p>
                            Confirming this action will update your status to Ready and notify the admin to prepare your voucher code.
                        </p>
                        <div className="assignment-ready-modal__button-container">
                            <AppButton type="button" label="Cancel" outline onClick={onHandleDismiss} disabled={loading} />
                            <AppButton type="button" label="Yes" onClick={handleConfirm} disabled={loading} />
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
});

AppAssignmentReadyModal.propTypes = {
};

export default memo(AppAssignmentReadyModal);
